var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightinline = function SvgArrowRightinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.434.834a.8.8 0 0 1 1.132 0l5.6 5.6a1 1 0 0 1 .083.098A.8.8 0 0 1 13.4 7l-.004-.08.004.051V7a1 1 0 0 1-.011.135.8.8 0 0 1-.223.43l.067-.076a1 1 0 0 1-.06.07l-.007.007-5.6 5.6a.8.8 0 1 1-1.132-1.132L10.668 7.8H1.4a.8.8 0 0 1-.794-.7L.6 7a.8.8 0 0 1 .8-.8h9.268L6.434 1.966A.8.8 0 0 1 6.357.924z"
  })));
};
export default SvgArrowRightinline;